module.exports = __webpack_public_path__ + "img/logo-full.1d09de4d.png";